<template>
  <div class="workspace">
    <TopHeader />
    <Navi />
    <fluidStudyBend />
    <div class="wrapper1">
      <div class="sidebar">
        <div class="goal">학습목표</div>

        <div class="title">인공지능 발전역사</div>
        <ul>
          <li>
            <div class="item" @click="changeContent(1)">
              <div class="iscomp active"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">머신러닝의 종류</div>
            </div>
          </li>
          <li>
            <div class="item" @click="changeContent(2)">
              <div class="iscomp"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">[Quiz]머신러닝의 종류2</div>
            </div>
          </li>
          <li>
            <div class="item">
              <div class="iscomp"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">[video]머신러닝의 종류3</div>
            </div>
          </li>
        </ul>

        <div class="title">인공지능 발전역사#2</div>
        <ul>
          <li>
            <div class="item">
              <div class="iscomp"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">머신러닝의 종류</div>
            </div>
          </li>
          <li>
            <div class="item">
              <div class="iscomp"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">[Quiz]머신러닝의 종류2</div>
            </div>
          </li>
          <li>
            <div class="item">
              <div class="iscomp"></div>
              <div class="icon">
                <img src="../assets/write.png" width="18px" />
              </div>
              <div class="_title">[video]머신러닝의 종류3</div>
            </div>
          </li>
        </ul>

        <!-- write -->
        <div class="crdContent" @click="newContent()">생성</div>
      </div>
      <div class="body">
        <Content :contentid="contentid" :m="m" />
      </div>
      <div class="grabber"></div>
      <div class="subinfo">subinfo</div>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/Header";
import Navi from "@/components/Navi";
import FluidStudyBend from "@/components/FluidStudyBend";
import Content from "@/components/Content";

export default {
  components: {
    TopHeader,
    Navi,
    FluidStudyBend,
    Content,
  },
  data() {
    return {
      contentid: 1,
      mode: 0,
      m: "old",
      showSubinfo: true,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val, old) {
        console.log(this.$route.query);
        let contentid = this.$route.query.contentid;
        let m = this.$route.query.m;
        this.m = m;
        if (contentid != null) {
          this.contentid = contentid;
        } else {
          this.contentid = "";
        }
      },
    },
  },
  methods: {
    changeContent(id) {
      // this.contentid = id;
      this.$router.push({ query: { contentid: id } });
    },
    newContent() {
      // console.log("newContent");
      this.$router.push({ query: { m: "new" } });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.wrapper1 {
  display: flex;
  min-height: calc(100vh - 156px);

  //   height: calc(100vh-50px);
  .sidebar {
    flex-grow: 0;
    flex-basis: 200px;
    flex-shrink: 0;
    background-color: $gray50;
    padding-top: 20px;
    position: relative;

    .goal {
      border-image: $gradient1;
      border-style: solid;
      border-image-slice: 1;
      border-image-width: 4px 4px 4px 4px;
      padding: 2px;
      text-align: center;
      margin: 0 10px 10px 10px;
      color: $gray600;
    }
    .crdContent {
      border-image: $gradient2;
      border-style: solid;
      border-image-slice: 1;
      border-image-width: 4px 4px 4px 4px;
      padding: 2px;
      text-align: center;
      // margin: 0 10px 10px 10px;
      color: $gray600;

      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }

    .title {
      font-weight: 700;
      font-size: 0.9em;
      font-family: $font;
      padding: 0 10px 10px 10px;
      margin-top: 10px;
    }
    ul {
      list-style-type: none;
      padding-inline-start: 0;
      margin: 0 auto;
      li {
        display: inline;
        .item {
          height: 40px;

          display: flex;
          align-content: center;

          .iscomp {
            flex-grow: 0;
            flex-basis: 5px;
          }
          .active {
            background-color: $point1;
          }

          .icon {
            flex-grow: 0;
            flex-basis: 30px;

            display: flex;
            justify-content: center;
            align-items: center;
          }
          ._title {
            flex-grow: 1;
            font-size: 0.8em;
            align-self: center;
            color: $gray500;

            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
        }
      }
    }
  }
  .body {
    flex-grow: 1;
  }
  .grabber {
    flex-grow: 0;
    flex-basis: 15px;
    background-color: $gray200;
  }
  .subinfo {
    flex-grow: 0;
    flex-basis: 250px;
    display: block;
    background-color: $gray50;
  }
}
</style>